module.exports = __webpack_public_path__ + "img/abapay.b0c9eb35.png";